import React, { useEffect, useRef } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FiAlertTriangle, FiHelpCircle } from 'react-icons/fi';

const VARIANT_CONFIG = {
  danger: {
    icon: FiAlertTriangle,
    iconBg: '#fee2e2',
    iconColor: '#b91c1c',
    btnVariant: 'danger',
  },
  warning: {
    icon: FiAlertTriangle,
    iconBg: '#fef3c7',
    iconColor: '#92400e',
    btnVariant: 'warning',
  },
  primary: {
    icon: FiHelpCircle,
    iconBg: '#dcfce7',
    iconColor: '#128c4a',
    btnVariant: 'primary',
  },
};

const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'primary',
  loading = false,
}) => {
  const cfg = VARIANT_CONFIG[variant] || VARIANT_CONFIG.primary;
  const Icon = cfg.icon;
  const titleId = useRef(`confirm-modal-${Math.random().toString(36).slice(2, 9)}`).current;
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (show && confirmBtnRef.current) {
      // Defer until modal is mounted/animated
      const t = setTimeout(() => confirmBtnRef.current?.focus(), 50);
      return () => clearTimeout(t);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onHide}
      centered
      backdrop={loading ? 'static' : true}
      keyboard={!loading}
      aria-labelledby={titleId}
    >
      <Modal.Body className="p-4">
        <div className="d-flex gap-3 align-items-start">
          <div
            aria-hidden="true"
            style={{
              width: 44,
              height: 44,
              minWidth: 44,
              borderRadius: 12,
              background: cfg.iconBg,
              color: cfg.iconColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon size={22} />
          </div>
          <div className="flex-grow-1">
            <h2 id={titleId} className="pp-h2 mb-2">
              {title}
            </h2>
            {message ? (
              <div className="text-secondary" style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>
                {message}
              </div>
            ) : null}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4">
        <Button variant="light" onClick={onHide} disabled={loading}>
          {cancelText}
        </Button>
        <Button
          ref={confirmBtnRef}
          variant={cfg.btnVariant}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Working…
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
